"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.router = router;
exports.route = route;
exports.applyRoute = applyRoute;
exports.pathMatcher = pathMatcher;
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _pathToRegexp = _interopRequireDefault(require("../utils/path-to-regexp"));

var _lodash = require("lodash");

function router(host) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options = (0, _objectSpread2["default"])({
    pathsGetter: 'available',
    pathProperty: 'toString',
    routerProperty: 'router',
    matcher: {}
  }, options);
  var _options = options,
      pathsGetter = _options.pathsGetter,
      pathProperty = _options.pathProperty,
      routerProperty = _options.routerProperty,
      matcher = _options.matcher;
  Object.defineProperty(host, routerProperty, {
    enumerable: false,
    configurable: false,
    get: function get() {
      return {
        filter: applyRoute,
        test: route,
        matcher: pathMatcher(matcher),
        get: function get(pattern) {
          var discard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          var pathsToTest = (0, _lodash.result)(host, pathsGetter, []).map(function (item) {
            return (0, _lodash.result)(item, pathProperty);
          });
          return applyRoute(pattern, pathsToTest, {
            discard: discard
          });
        }
      };
    }
  });
  return (0, _lodash.get)(host, options.routerProperty);
}

var _default = router;
exports["default"] = _default;

function route(pattern) {
  var matcher = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return pathMatcher(matcher)(pattern);
}

function applyRoute() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';
  var pathsToTest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof pathsToTest === 'function') {
    pathsToTest = pathsToTest(options.matcher || {});
  }

  if (typeof pathsToTest === 'string') {
    pathsToTest = [pathsToTest];
  }

  var matcher = route(pattern);
  var matches = [];
  var failures = [];
  pathsToTest.forEach(function (path, index) {
    var matchResult = matcher(path);

    if (matchResult === false) {
      failures.push([path, index]);
    } else {
      matches.push({
        result: matchResult,
        index: index,
        path: path,
        pattern: pattern
      });
    }
  });

  if (options.discard) {
    return matches;
  }

  return {
    failures: failures,
    matches: matches,
    pattern: pattern,
    pathsToTest: pathsToTest
  };
}
/*eslint-disable*/


function pathMatcher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  /**
   * String decoder
   * @param {String} str
   * @returns {*}
   */

  function decodeUri(str) {
    try {
      str = decodeURIComponent(str);
    } catch (e) {
      throw new Error('Cannot decodeURIComponent: ' + str);
    }

    return str;
  }

  return function (route) {
    var keys = [],
        reg = _pathToRegexp["default"].call(this, [route, keys, options]);

    return function (route, params) {
      var res = reg.exec(route),
          params = params || {};
      if (!res) return false;

      for (var i = 1, l = res.length; i < l; i++) {
        if (res[i] === undefined) continue;
        params[keys[i - 1].name] = decodeUri(res[i]);
      }

      return params;
    };
  };
}